import React from 'react';
import PropTypes from 'prop-types';
import { getFaresSpecialOffers } from '../../../_integrations/everymundo/specialOffers';

import FareListContainerMobile from '../FareListContainerMobile';

const SpecialOffersContainer = (props) => (
  <FareListContainerMobile {...props} getFares={getFaresSpecialOffers} />
);

SpecialOffersContainer.componentName = 'SpecialOffersContainerMobile';

SpecialOffersContainer.propTypes = {
  /**
   * Parameters tracking
   */
  tracking: PropTypes.objectOf(PropTypes.any)
};

SpecialOffersContainer.defaultProps = {
  tracking: {
    flexibleDates: false,
    passengerCount: 1,
    promoCode: 'EVERYMUNDO',
    eventType: 'specialOffersContainer'
  }
};

export default SpecialOffersContainer;
